import { render, staticRenderFns } from "./ChargeSetting.vue?vue&type=template&id=28969810&"
import script from "./ChargeSetting.vue?vue&type=script&lang=js&"
export * from "./ChargeSetting.vue?vue&type=script&lang=js&"
import style0 from "./ChargeSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports